module.exports = __webpack_public_path__ + "resources/img/career-welfareImg2.3a03b95d.jpg";